// extracted by mini-css-extract-plugin
export var children = "BackGroundCover-module--children--uiSdF";
export var container = "BackGroundCover-module--container--Tb6XZ";
export var containerWithoutLogo = "BackGroundCover-module--containerWithoutLogo--NrA3E";
export var decorator = "BackGroundCover-module--decorator--ei0G1";
export var decoratorWrapper = "BackGroundCover-module--decoratorWrapper---Eapy";
export var logo = "BackGroundCover-module--logo--5jk57";
export var logoWrapper = "BackGroundCover-module--logoWrapper--0DfJk";